var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenPattern = function SvgGreenPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0B753E",
    strokeLinecap: "round",
    d: "M1 2.563A5084 5084 0 0 1 53.748 1c-10.084.833-31.96 3-38.785 5C26.08 5.167 55.454 3.563 84 3.813"
  })));
};
export default SvgGreenPattern;